export default "__VITE_ASSET__DLgLvQn6__"